import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/controls-data');

const ControlsDataFxs = {
    getFx: domain.effect(api.controlsData.get),
};

export default ControlsDataFxs;
